import React from 'react';
import { ToolResultProps } from '../types';
import ReactMarkdown from 'react-markdown';

const DocumentEditResult: React.FC<ToolResultProps> = ({ thought }) => {
  const { success, content, toolResult } = thought;
  const isSuccess = success !== false;
  const description = content || toolResult?.content || thought.thought || 'Document edited';
  
  return (
    <div className="mt-1.5 px-1">
      {/* Eliminado el header redundante - ya se muestra en ThoughtItem */}
      <div className={`text-[11px] leading-relaxed ${isSuccess ? 'text-foreground/70' : 'text-red-700/80'}`}>
        <ReactMarkdown
          components={{
            p: ({ node, ...props }: any) => <p className="mb-1 last:mb-0" {...props} />,
            ul: ({ node, ...props }: any) => <ul className="my-1 pl-3 list-disc opacity-90" {...props} />,
            li: ({ node, ...props }: any) => <li className="my-0.5" {...props} />,
            code: ({ node, inline, ...props }: any) => 
              inline ? (
                <code className="bg-muted px-1 rounded text-[10px] font-mono" {...props} />
              ) : (
                <code className="block bg-muted/50 p-1.5 my-1 rounded text-[10px] font-mono overflow-auto max-h-32" {...props} />
              ),
          }}
        >
          {description}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default DocumentEditResult;

